'use client';

import { AUTH_EVENTS } from '@repo/analytics';
import { LoginTemplate } from '@repo/design-system';
import { setPendingAuthMethod, trackEvent } from '@repo/web-chrome/lib/analytics';

interface ILoginWithAnalyticsProps {
  errorMessage?: string | null;
}

export function LoginWithAnalytics({ errorMessage }: ILoginWithAnalyticsProps): React.JSX.Element {
  const handleProviderStart = (method: string): void => {
    setPendingAuthMethod(method);
    trackEvent(AUTH_EVENTS.signInStarted, { method });
  };

  return <LoginTemplate errorMessage={errorMessage} onProviderStart={handleProviderStart} />;
}
